/**
 * @author: Angel Labrada Massó
 * @version: v0.0.1
 * @date:
 */
import React, { memo } from 'react';

const MultiBanner = () => {
  return (
    <svg width='27' height='15' viewBox='0 0 27 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='6.27734' y='0.0488281' width='13.0736' height='6.79827' rx='1.38844' fill='white' />
      <rect y='0.0488281' width='5.22944' height='8.89005' rx='1.38844' fill='white' />
      <rect y='9.46094' width='5.22944' height='5.22944' rx='1.38844' fill='white' />
      <rect x='20.3945' y='5.80078' width='5.75238' height='8.89005' rx='1.38844' fill='white' />
      <rect x='6.27734' y='7.89062' width='6.27533' height='6.79827' rx='1.38844' fill='white' />
      <rect x='13.5938' y='7.89062' width='5.75238' height='6.79827' rx='1.38844' fill='white' />
      <rect x='20.3945' y='0.0488281' width='5.75238' height='5.22944' rx='1.38844' fill='white' />
    </svg>
  );
};

export default memo(MultiBanner);
